/**
 * Presentational popover body: single-select radio list grouped by category titles.
 * Selection updates draft via onChange and closes the popover.
 */
import FontBody4 from "../../../../../../../../../../../../components/fonts/font-body4/font-body4";
import { FONT_COLOR } from "../../../../../../../../../../../../components/fonts/font-props";
import RmaListFilterRadioOption, {
    IRmaListFilterRadioOption,
    RmaListFilterOptionId,
} from "../radio-option/rma-list-filter-radio-option";
import { RmaListFilterRadioGroupProvider } from "../radio-option/rma-list-filter-radio-group-context/rma-list-filter-radio-group-context";
import { useRmaListFilterPopoverClose } from "../../../../rma-list-filter-popover-close-context/rma-list-filter-popover-close-context";
import "./rma-list-filter-grouped-options-content.scss";

export interface IRmaListFilterGroupedOptionsContentGroup {
    title: string;
    options: IRmaListFilterRadioOption[];
}

export interface IRmaListFilterGroupedOptionsContentProps {
    value: RmaListFilterOptionId | null;
    groups: IRmaListFilterGroupedOptionsContentGroup[];
    onChange: (id: RmaListFilterOptionId) => void;
}

const RADIO_GROUP_NAME = "rma-list-filter-grouped-options";

const RmaListFilterGroupedOptionsContent: React.FC<IRmaListFilterGroupedOptionsContentProps> = ({
    value,
    groups,
    onChange,
}) => {
    const onRequestClose = useRmaListFilterPopoverClose();

    const onSelect = (id: RmaListFilterOptionId) => {
        onChange(id);
        onRequestClose();
    };

    return (
        <RmaListFilterRadioGroupProvider
            name={RADIO_GROUP_NAME}
            value={value}
            onSelect={onSelect}
        >
            <div className="rma-list-filter-grouped-options-content" role="radiogroup">
                {groups.map((group) => (
                    <div key={group.title} className="rma-list-filter-grouped-options-content__group">
                        {!!group.title && 
                            <div className="rma-list-filter-grouped-options-content__group-title">
                                <FontBody4 color={FONT_COLOR.NEUTRAL3}>{group.title}</FontBody4>
                            </div>
                        }
                        {group.options.map((option) => (
                            <RmaListFilterRadioOption key={option.id} option={option} />
                        ))}
                    </div>
                ))}
            </div>
        </RmaListFilterRadioGroupProvider>
    );
};

export default RmaListFilterGroupedOptionsContent;
